import Icon from '../components/Icon.vue'

Icon.register({
  'mug-hot': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M127.1 146.5c-2.7-16.6-10.4-31.9-22.4-44.1-22.6-23.1-36.7-52.5-40.6-84.4-1.1-9.5 6.5-18 16.3-18h16.4c8.2 0 15 5.9 16.1 13.8 2.8 20.2 12 38.8 26.4 53.5 20.2 20.5 32.8 46.5 36.6 74.7 1.3 9.5-6.5 18-16.3 18h-16.5c-8 0-14.7-5.8-16-13.5zM239.1 146.5c-2.7-16.6-10.4-31.9-22.4-44.1-22.6-23.1-36.7-52.5-40.6-84.4-1.2-9.5 6.5-18 16.3-18h16.4c8.2 0 15 5.9 16.1 13.8 2.8 20.2 12 38.8 26.4 53.5 20.2 20.5 32.8 46.5 36.6 74.7 1.3 9.5-6.5 18-16.3 18h-16.5c-8 0-14.7-5.8-16-13.5zM400 192c61.8 0 112 50.2 112 112s-50.2 112-112 112h-16c0 53-43 96-96 96h-192c-53 0-96-43-96-96v-192c0-17.7 14.3-32 32-32h368zM400 352c26.5 0 48-21.5 48-48s-21.5-48-48-48h-16v96h16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/mug-hot.js
// module id = 1590
// module chunks = 0